import { deleteOrganizationLogoDefinition } from "@snubes/snubes-types";
import { getCallable } from "../../Firebase/helpers/getCallable";

export const deleteOrganizationLogoCallable = getCallable(
  deleteOrganizationLogoDefinition,
);
